import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import{UserServices} from '../services/userservices.service'

@Component({
  selector: 'app-uploadresults',
  templateUrl: './uploadresults.component.html',
  styleUrls: ['./uploadresults.component.css']
})
export class UploadresultsComponent implements OnInit {

  patientDetails:any;
  userProfileImage: string = "assets/img/user.png";
  documentFile:any;
  selectedDocumentFile:any;
  constructor(private userServices:UserServices) {
    debugger
    this.patientDetails=this.userServices.getPatientData()
    console.log(this.patientDetails)
    //this.userProfileImage = 'https://s3.amazonaws.com/sasadoctorimages/profileImages/03878b60-4b12-11e9-ab94-e305d8838097.JPG'
    this.userProfileImage=this.patientDetails.patientIdentityImagePath;
   }
  

  ngOnInit() {
  }
  
  getUploadFile(imageInput: any, event: any) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      this.documentFile = event.target.files[0];
      reader.readAsDataURL(event.target.files[0]); // read file as data url
  
      reader.onload = (e:any) => { 
        // called once readAsDataURL is completed
        debugger
        this.selectedDocumentFile = e.target.result;
      }
    }
  }

  uploadDocument() { 
   
    var loginUser = JSON.parse(localStorage.getItem('currentUser'));
    var form_data = new FormData();
     form_data.append('token', loginUser.token);    
     form_data.append('userid', this.patientDetails.patientId); 
     form_data.append('patientid', this.patientDetails.patientId); 
     form_data.append('document', this.documentFile);
     this.userServices.uploadLabResult(form_data).subscribe(
      data => {
          if (data.returnCode == 0) {
              alert("Document uploaded sucessfully")
              console.log('result')
              console.log(data)             
          }
          else {
              alert(data.returnMsg);  
          }
      },
      error => {
          // this.alertService.error(error);
          // this.loading = false;         
          alert(error)
          console.log(error)
      });
    }  
  


}
